import { TWardrobeItem } from '@typings'

export const isItemInMkt = (wardrobeItem: TWardrobeItem | undefined): boolean =>
	!!wardrobeItem && wardrobeItem.status === 'sale'

export const isItemOnReview = (wardrobeItem: TWardrobeItem) =>
	['on-review', 'rejected'].includes(wardrobeItem?.marketplaceInformation.status)
